import { Component, Vue, Prop } from 'vue-property-decorator';
import {clickOutside} from '@/directives/clickOutside';
import PincodeInput from 'vue-pincode-input';

@Component({
  components:{
    PincodeInput
  },
  directives: {
    outside: clickOutside
  }
})
export default class ModalAccept extends Vue {
  @Prop({ default: 'Yes' }) apply!: string
  @Prop({ default: 'No' }) cancel!: string
  @Prop({ default: '' }) headerText!: string
  @Prop({ default: '' }) contentText!: string
  @Prop({ default: false }) hideApply!: boolean
  @Prop({ default: false }) hideCancel!: boolean
  @Prop({ default: false }) showPin!: boolean

  pin: string = '';


  reject(){

    this.$emit('reject');

  }

  resolve(){

    this.$emit('resolve', this.pin);

  }
}